<template>
  <div class="Wechat">

    <div class="swiper-container WeChatswiper"
         style="width: 100vw;height: 100vh;overflow: hidden;">
      <div class="swiper-wrapper">
        <!-- 第一屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <Banner></Banner>
        </div>
        <!-- 第二屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <div style="height: 100%"
               data-scroll="true">

            <el-scrollbar ref="WeChatscroll"
                          style="height: 100%">
              <div style="margin-bottom:0.4167rem;margin-top:0.3646rem">
                <div class="title_box">小程序/公众号定制开发服务</div>
                <div class="title_info">介入微信开放平台小程序、公众号开发，为亿万微信用户提供轻便的服务</div>
                <div class="development">
                  <div class="IOS phone">
                    <div class="img_box"></div>
                    <div class="title">小程序/公众号开发</div>
                    <div class="text_info">
                      微信企业号开发
                      微信公众号（服务号、订阅号）开发
                      微信与APP功能跨平台同步开发
                    </div>
                  </div>
                  <div class="Android phone">
                    <div class="img_box"></div>
                    <div class="title">混合应用开发</div>
                    <div class="text_info">采用目前最先进的混合开发模式，结合实际的需求与功能，定制高性能轻量级的混合应用</div>
                  </div>
                </div>
              </div>
              <div>
                <div class="title_box">基于微信，又不止于微信</div>
                <div class="title_info">利用微信/小程序丰富的API及组件能力，对接强大的微信生态</div>
                <div class="ecology_box">
                  <div class="ecology_li">
                    <h4>微信官网</h4>
                    <div class="img_box">
                      <img src="../../static/images/img/weiguanwang.png"
                           alt="">
                    </div>
                    <p>
                      利用微信开发能力结合原声技术开发
                      用于微信浏览的网站
                    </p>
                  </div>
                  <div class="ecology_li">
                    <h4>小程序</h4>
                    <div class="img_box">
                      <img src="../../static/images/img/xioachengxu.png"
                           alt="">
                    </div>
                    <p>
                      免安装、易推广，拥有丰富组件及API能力
                    </p>
                  </div>
                  <div class="ecology_li">
                    <h4>微信商城</h4>
                    <div class="img_box">
                      <img src="../../static/images/img/weixinshangcheng.png"
                           alt="">
                    </div>
                    <p>
                      基于微信支付、微信登录等能力的电子商务商城
                    </p>
                  </div>
                  <div class="ecology_li">
                    <h4>微信活动</h4>
                    <div class="img_box">
                      <img src="../../static/images/img/weixinhuodong.png"
                           alt="">
                    </div>
                    <p>
                      基于微信开发能力使用户更加便捷参与活动
                    </p>
                  </div>
                  <div class="ecology_li">
                    <h4>微信报名</h4>
                    <div class="img_box">
                      <img src="../../static/images/img/weixinbaoming.png"
                           alt="">
                    </div>
                    <p>
                      基于微信开放能力方便用户快速参与线上报名
                    </p>
                  </div>
                  <div class="ecology_li">
                    <h4>微信投票</h4>
                    <div class="img_box">
                      <img src="../../static/images/img/weixintoupiao.png"
                           alt="">
                    </div>
                    <p>
                      基于微信开放能力限制微信投票刷票等行为
                    </p>
                  </div>
                  <div class="ecology_li">
                    <h4>微信O2O</h4>
                    <div class="img_box">
                      <img src="../../static/images/img/weixino2o.png"
                           alt="">
                    </div>
                    <p>
                      基于微信支付、LBS的开发能力开放本地化O2O平台
                    </p>
                  </div>
                  <div class="ecology_li">
                    <h4>更多应用</h4>
                    <div class="img_box">
                      <img src="../../static/images/img/gengduoyingyong.png"
                           alt="">
                    </div>
                    <p>
                      扫码购物、微订单等更多基于微信开放能力应用
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div class="title_box">小程序/公众号流量入口</div>
                <div class="title_info">众多流量入口，集展示、互动、交易为一体，抢占市场，抓住机遇</div>
                <div class="flow_box">
                  <div class="flow_li"
                       v-for="item,index in flowList"
                       :key="index">
                    <div class="img_box">
                      <img :src="item.url"
                           alt="">
                    </div>
                    <div class="text">
                      {{item.title}}
                    </div>
                  </div>
                </div>
              </div>
              <Footer></Footer>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Banner,
    Footer,
  },
  data () {
    return {
      flowList: [
        {
          title: '附近小程序',
          url: require("../../static/images/img/fujinxioachengxu.png")
        }, {
          title: '二维码',
          url: require("../../static/images/img/erweima.png")
        }, {
          title: '微信模糊搜索',
          url: require("../../static/images/img/weixinmohusousuo.png")
        }, {
          title: '商家公众关联',
          url: require("../../static/images/img/shangjiagongzhonghaoguanlian.png")
        }, {
          title: '好友分享',
          url: require("../../static/images/img/haoyoufenxiang.png")
        }, {
          title: '微信群分享',
          url: require("../../static/images/img/weixinqunfenxiang.png")
        }, {
          title: '文章推送',
          url: require("../../static/images/img/wenzhangtuisong.png")
        }, {
          title: '消息通知',
          url: require("../../static/images/img/xiaoxitongzhi.png")
        }, {
          title: '置顶小程序',
          url: require("../../static/images/img/zhidingxiaochengxu.png")
        }, {
          title: '客服咨询',
          url: require("../../static/images/img/kefuzixun.png")
        }, {
          title: '小程序互跳',
          url: require("../../static/images/img/xiaochengxuhutiao.png")
        }, {
          title: '支付完成页面',
          url: require("../../static/images/img/zhifuwanchengyemian.png")
        }, {
          title: '群小程序记录',
          url: require("../../static/images/img/qunxiaochengxujilu.png")
        }, {
          title: '搜索界面小程序',
          url: require("../../static/images/img/sousuoxiaochengxu.png")
        }, {
          title: '常用列表',
          url: require("../../static/images/img/changyongliebiao.png")
        },
      ],
      WeChatswiper: '',
      WeChatswiperId: 0,
      scrollTop: 0,
    }
  },
  watch: {
    WeChatswiperId: {
      handler (e) {
        if (e == 1) {
          this.$refs.WeChatscroll.wrap.scrollTop = 1
          this.WeChatswiper.disableMousewheelControl()
        }
      }
    }
  },
  mounted () {
    var _this = this
    this.$refs.WeChatscroll.wrap.onscroll = (e) => {
      _this.scrollTop = e.target.scrollTop
      if (e.target.scrollTop == 0) {
        _this.WeChatswiper.slidePrev()
        _this.WeChatswiper.enableMousewheelControl()
      }
    }

    this.WeChatswiper = new Swiper('.WeChatswiper', {
      direction: 'vertical',
      loop: false, //不循环
      spaceBetween: 0, // swiper-slide 间的距离为0
      autoplay: false, // 不自动切换
      speed: 700, // 每次切换时长
      // scrollbar: '.swiper-scrollbar', // 滚动条
      mousewheelControl: true, // 开启鼠标切换
      noSwiping: true,// 开启不允许切换
      onSlideChangeEnd: function (swiper) {
        _this.WeChatswiperId = swiper.activeIndex
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.Wechat {
  text-align: center;
  .title_box {
    display: inline-block;
    position: relative;
    font-size: 0.2103rem;
    font-family: MicrosoftYaHei;
    color: #000;
    opacity: 1;
    margin: 0.225rem 0 0.1383rem;
  }
  .title_box::before {
    content: "";
    position: absolute;
    left: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_left.png");
    background-size: 100% 100%;
  }
  .title_box::after {
    content: "";
    position: absolute;
    right: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_right.png");
    background-size: 100% 100%;
  }
  .title_info {
    font-size: 0.1146rem;
    font-family: MicrosoftYaHei;
    line-height: 0.2083rem;
    color: #999999;
    opacity: 1;
  }
  .banner_box {
    width: 100vw;
    height: 100vh;
  }
  .development {
    margin-top: 0.3125rem;
    padding: 0 2.526rem;
    display: flex;
    .phone {
      flex: 1;
      cursor: pointer;
      .img_box {
        width: 0.7917rem;
        height: 0.9271rem;
        margin: 0 auto;
        background-color: #fff;
        background-size: 100% 100%;
        transition: 0.3s;
      }
      .title {
        font-size: 0.1667rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 0.2083rem;
        color: #000000;
        opacity: 1;
        margin: 0.0833rem 0 0.1563rem;
      }
      .text_info {
        font-size: 0.0938rem;
        font-family: MicrosoftYaHei;
        line-height: 0.1458rem;
        color: #666666;
        opacity: 1;
      }
    }
    .IOS {
      margin-right: 0.3906rem;
      .img_box {
        width: 1.1354rem;
        height: 0.9271rem;
        background-image: url("../../static/images/img/weixin.png");
      }
    }
    .IOS:hover {
      .img_box {
        background-image: url("../../static/images/img/weixinSelected.png");
      }
    }
    .Android {
      margin-left: 0.3906rem;
      .img_box {
        width: 0.788rem;
        height: 0.9271rem;
        background-image: url("../../static/images/img/yingyong.png");
      }
    }
    .Android:hover {
      .img_box {
        background-image: url("../../static/images/img/yingyongSelected.png");
      }
    }
  }
  .ecology_box {
    margin: 0 1.875rem;
    margin-top: 0.2563rem;
    margin-bottom: 0.2083rem;
    display: flex;
    flex-wrap: wrap;
    .ecology_li {
      padding: 0.1042rem 0.1979rem;
      border: 0.0052rem solid #c9c9c9;
      h4 {
        font-weight: 400;
        font-size: 0.0938rem;
        font-family: MicrosoftYaHei;
        line-height: 0.1458rem;
        color: #333333;
        letter-spacing: 0.0052rem;
        opacity: 1;
      }
      .img_box {
        width: 0.2083rem;
        height: 0.2083rem;
        margin: 0.1042rem auto 0.0833rem;
      }
      p {
        width: 1.148rem;
        font-size: 0.0729rem;
        font-family: MicrosoftYaHei;
        line-height: 0.1146rem;
        color: #999999;
        opacity: 1;
      }
    }
  }
  .flow_box {
    margin: 0.3125rem 1.875rem 0.4688rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .flow_li {
      margin-right: 0.6167rem;
      margin-bottom: 0.1563rem;
      width: 0.7483rem;
      .img_box {
        width: 0.5208rem;
        height: 0.5208rem;
        margin: 0 auto 0.0533rem;
      }
      .text {
        font-size: 0.099rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 0.2083rem;
        color: #333333;
        letter-spacing: 0.0052rem;
        opacity: 1;
      }
    }
    .flow_li:nth-child(5) {
      margin-right: 0rem;
    }
    .flow_li:nth-child(10) {
      margin-right: 0rem;
    }
    .flow_li:nth-child(15) {
      margin-right: 0rem;
    }
  }
  img {
    height: 100%;
    width: 100%;
  }
}
</style>